import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY;

export const getDestinations = async () => {
    try {
        const result = await api.get(`${urlApi}/sumaTravel/getDestinations`);
        console.log(result.data)
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const addDestination = async (data) => {
    try {
        const result = await api.post(`${urlApi}/sumaTravel/addDestination`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const updateDestination = async (data) => {
    try {
        const result = await api.post(`${urlApi}/sumaTravel/updateDestination`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}

export const disableDestination = async (data) => {
    try {
        const result = await api.post(`${urlApi}/sumaTravel/disableDestination`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}